import { styled, TableCell } from '@mui/material';

type DayHeaderCellProps = {
  label: string;
  rowSpan: number;
};

export const DayHeaderCell = ({ label, rowSpan }: DayHeaderCellProps) => (
  <StyledDaysCell rowSpan={rowSpan}>{label}</StyledDaysCell>
);

const StyledDaysCell = styled(TableCell)({
  fontWeight: 'bold',
  width: '30%',
  verticalAlign: 'top',
  textTransform: 'capitalize',
});
